var _g, _defs;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgSequence(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 396,
    height: 318,
    viewBox: "0 0 396 318",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_5_131)"
  }, /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip1_5_131)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M0 67.5049L0 250.165C0 287.447 30.1402 317.67 67.32 317.67H328.68C365.86 317.67 396 287.447 396 250.165V67.5049C396 30.223 365.86 0 328.68 0H67.32C30.1402 0 0 30.223 0 67.5049Z",
    fill: "#111111"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M0 67.5049L0 250.165C0 287.447 30.1402 317.67 67.32 317.67H328.68C365.86 317.67 396 287.447 396 250.165V67.5049C396 30.223 365.86 0 328.68 0H67.32C30.1402 0 0 30.223 0 67.5049Z",
    fill: "url(#paint0_linear_5_131)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M98.9999 79.4176C98.9999 68.4523 90.1351 59.5632 79.1999 59.5632C68.2647 59.5632 59.3999 68.4523 59.3999 79.4176C59.3999 90.3828 68.2647 99.272 79.1999 99.272C90.1351 99.272 98.9999 90.3828 98.9999 79.4176Z",
    fill: "url(#paint1_linear_5_131)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M98.9999 79.4176C98.9999 68.4523 90.1351 59.5632 79.1999 59.5632C68.2647 59.5632 59.3999 68.4523 59.3999 79.4176C59.3999 90.3828 68.2647 99.272 79.1999 99.272C90.1351 99.272 98.9999 90.3828 98.9999 79.4176Z",
    fill: "url(#paint2_linear_5_131)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M98.9999 79.4176C98.9999 68.4523 90.1351 59.5632 79.1999 59.5632C68.2647 59.5632 59.3999 68.4523 59.3999 79.4176C59.3999 90.3828 68.2647 99.272 79.1999 99.272C90.1351 99.272 98.9999 90.3828 98.9999 79.4176Z",
    fill: "url(#paint3_linear_5_131)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M98.9999 238.126C98.9999 227.161 90.1351 218.272 79.1999 218.272C68.2647 218.272 59.3999 227.161 59.3999 238.126C59.3999 249.092 68.2647 257.981 79.1999 257.981C90.1351 257.981 98.9999 249.092 98.9999 238.126Z",
    fill: "url(#paint4_linear_5_131)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M336.6 158.835C336.6 147.87 327.735 138.981 316.8 138.981C305.865 138.981 297 147.87 297 158.835C297 169.8 305.865 178.69 316.8 178.69C327.735 178.69 336.6 169.8 336.6 158.835Z",
    fill: "url(#paint5_linear_5_131)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M336.6 158.835C336.6 147.87 327.735 138.981 316.8 138.981C305.865 138.981 297 147.87 297 158.835C297 169.8 305.865 178.69 316.8 178.69C327.735 178.69 336.6 169.8 336.6 158.835Z",
    fill: "url(#paint6_linear_5_131)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M316.8 59.5632H158.4C147.465 59.5632 138.6 68.4523 138.6 79.4176C138.6 90.3828 147.465 99.272 158.4 99.272H316.8C327.735 99.272 336.6 90.3828 336.6 79.4176C336.6 68.4523 327.735 59.5632 316.8 59.5632Z",
    fill: "url(#paint7_linear_5_131)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M316.8 218.272H158.4C147.465 218.272 138.6 227.161 138.6 238.126C138.6 249.092 147.465 257.981 158.4 257.981H316.8C327.735 257.981 336.6 249.092 336.6 238.126C336.6 227.161 327.735 218.272 316.8 218.272Z",
    fill: "url(#paint8_linear_5_131)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M237.6 138.981H79.2C68.2648 138.981 59.4 147.87 59.4 158.835C59.4 169.8 68.2648 178.69 79.2 178.69H237.6C248.535 178.69 257.4 169.8 257.4 158.835C257.4 147.87 248.535 138.981 237.6 138.981Z",
    fill: "url(#paint9_linear_5_131)"
  })))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_5_131",
    x1: 198,
    y1: 0.0000405854,
    x2: 198,
    y2: 318,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#1D273D"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#0D0F13"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint1_linear_5_131",
    x1: 65.5,
    y1: 99,
    x2: 92.5,
    y2: 63,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#4462FE"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#7D69FA"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint2_linear_5_131",
    x1: 62.8799,
    y1: 99.2912,
    x2: 96.1377,
    y2: 97.5911,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#3757FD"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#6980FA"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint3_linear_5_131",
    x1: 62.8799,
    y1: 99.2912,
    x2: 96.1377,
    y2: 97.5911,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#2447FF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#6980FA"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint4_linear_5_131",
    x1: 65,
    y1: 251.5,
    x2: 91.5,
    y2: 223.5,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#BC3EE6"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#D972F1"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint5_linear_5_131",
    x1: 305,
    y1: 172,
    x2: 329.5,
    y2: 146,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#29BDFF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#96E7FB"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint6_linear_5_131",
    x1: 300.18,
    y1: 178.418,
    x2: 334.567,
    y2: 176.772,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#23BBFF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#85E7FF"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint7_linear_5_131",
    x1: 154.5,
    y1: 99,
    x2: 317.5,
    y2: 60,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#23BBFF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#85E7FF"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint8_linear_5_131",
    x1: 156,
    y1: 258,
    x2: 312.5,
    y2: 218,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#2447FF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#6980FA"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint9_linear_5_131",
    x1: 86.0001,
    y1: 179,
    x2: 235.5,
    y2: 139,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#6634FF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#9C6DFF"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_5_131"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 396,
    height: 317.67,
    fill: "white"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip1_5_131"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 396,
    height: 317.67,
    fill: "white"
  })))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgSequence);
export default __webpack_public_path__ + "static/media/sequence.7c854742a6b8b4969004976a67f5ac61.svg";
export { ForwardRef as ReactComponent };